// global-error-handler.service.ts
import { ErrorHandler, Injectable } from '@angular/core';
import { TechnicalAnalyticsService } from './technical-analytics.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private technicalAnalytics: TechnicalAnalyticsService) {}

  handleError(error: any) {
    // Get meaningful error information
    const errorMessage = error.message || String(error);
    const errorCode = error.code || 'unknown';
    const stack = error.stack || '';

    // Log to analytics
    this.technicalAnalytics.trackError(
      errorCode,
      errorMessage,
      this.getActiveComponent()
    );

    // Continue with normal error handling
    console.error('An error occurred:', error);
  }

  private getActiveComponent(): string {
    // This is a simplified implementation
    // A real implementation would need to get the current route/component
    return 'unknown';
  }
}
